import React from 'react';

const Footer = () => {
  return (
    <footer id="footer" className="footer">
      {/* <div className="footer-newsletter">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-6">
              <h4>Join Our Newsletter</h4>
              <p>Subscribe to our newsletter and receive the latest news about our products and services!</p>
              <form action="#newsletter" method="post" className="php-email-form">
                <div className="newsletter-form">
                  <input type="email" name="email" />
                  <input type="submit" value="Subscribe" />
                </div>
                <div className="loading">Loading</div>
                <div className="error-message"></div>
                <div className="sent-message">Your subscription request has been sent. Thank you!</div>
              </form>
            </div>
          </div>
        </div>
      </div> */}

      <div className="container footer-top">
        <div className="row gy-6">
          <div className="col-lg-6 col-md-6 footer-about">
            <a href="#hero" className="d-flex align-items-center">
              <img src='assets/img/logo.jpeg' style={{width:250}}/>
            </a>
            <div className="footer-contact pt-3">
              <p>Marketing Office:</p>
                  <p>SWOTONN LABS </p> 
<p> C-401</p>
<p>AASHRAY,  SHILAJ </p> 
<p>AHMEDABAD - 380059</p>
              <p className="mt-3"><strong>Phone:</strong> <span>+91 9826176756</span></p>
              <p><strong>Email:</strong> <span>swotonnlabs@gmail.com</span></p>
            </div>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><i className="bi bi-chevron-right"></i> <a href="#hero">Home</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#about">About us</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Services</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#contact">Terms of service</a></li>
            </ul>
          </div>

          {/* <div className="col-lg-2 col-md-3 footer-links">
            <h4>Our Services</h4>
            <ul>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Web Design</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Web Development</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Product Management</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Marketing</a></li>
            </ul>
          </div> */}

          <div className="col-lg-4 col-md-12">
            <h4>Follow Us</h4>
            <p>Cras fermentum odio eu feugiat lide par naso tierra videa magna derita valies</p>
            <div className="social-links d-flex">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="bi bi-twitter-x"></i></a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="bi bi-facebook"></i></a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><i className="bi bi-instagram"></i></a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><i className="bi bi-linkedin"></i></a>
            </div>
          </div>
        </div>
      </div>

      <div className="container copyright text-center mt-4">
        <p>© <span>Copyright</span> <strong className="px-1 sitename">eNno</strong> <span>All Rights Reserved</span></p>
        <div className="credits">
          Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a> Distributed by <a href="https://themewagon.com">ThemeWagon</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
